import './ShareButton.svelte.css';
/* src/components/ShareButton.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	attr,
	binding_callbacks,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	safe_not_equal
} from "../../_snowpack/pkg/svelte/internal.js";

import { onMount } from "../../_snowpack/pkg/svelte.js";

function create_if_block(ctx) {
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			button.textContent = "share";
			attr(button, "class", "jd-primary-button svelte-146k1mf");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			/*button_binding*/ ctx[4](button);

			if (!mounted) {
				dispose = listen(button, "click", /*handleShare*/ ctx[2]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			/*button_binding*/ ctx[4](null);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*shareSupported*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*shareSupported*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

const title = "My Johnny•Decimal Index";

function instance($$self, $$props, $$invalidate) {
	let { text = "" } = $$props;
	let shareSupported = false;
	let buttonRef;

	const handleShare = () => {
		if (!shareSupported) return alert("share not supported");

		navigator.share({ title, text, url: window.location.href }).then(() => {
			buttonRef.blur();
		}).catch(err => {
			console.error(`Couldn't share because of`, err.message);
		});
	};

	onMount(() => {
		if (navigator.share) {
			$$invalidate(0, shareSupported = true);
		}
	});

	function button_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			buttonRef = $$value;
			$$invalidate(1, buttonRef);
		});
	}

	$$self.$$set = $$props => {
		if ("text" in $$props) $$invalidate(3, text = $$props.text);
	};

	return [shareSupported, buttonRef, handleShare, text, button_binding];
}

class ShareButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { text: 3 });
	}
}

export default ShareButton;